export class CulturalIdentity {
	id: number
	name: string
	key: string
	sortOrder: number
	createdAt: string
	updatedAt: string

	constructor(data: {
		id: number
		name: string
		key: string
		sortOrder: number
		createdAt: string
		updatedAt: string
	}) {
		this.id = data.id
		this.name = data.name
		this.key = data.key
		this.sortOrder = data.sortOrder
		this.createdAt = data.createdAt
		this.updatedAt = data.updatedAt
	}

	static create(data: Partial<CulturalIdentity>): CulturalIdentity {
		const defaultValues = {
			id: 0,
			name: '',
			key: '',
			sortOrder: 0,
			createdAt: '',
			updatedAt: '',
		}

		return new CulturalIdentity({ ...defaultValues, ...data })
	}
}
